"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.list = [
    {
        a: "'",
        z: "'",
    },
    {
        a: "(",
        z: ")"
    },
    {
        a: "[",
        z: "]"
    },
    {
        a: "{",
        z: "}"
    },
    {
        a: "<",
        z: ">"
    },
    {
        a: "/",
        z: "/"
    },
    {
        a: "\\",
        z: "\\"
    },
    {
        a: "`",
        z: "`"
    },
    {
        a: "\"",
        z: "\"",
    },
    {
        a: "*",
        z: "*"
    },
    {
        a: "“",
        z: "”"
    },
    {
        a: "„",
        z: "“"
    },
    {
        a: "»",
        z: "‏«"
    },
    {
        a: "«",
        z: "»"
    },
    {
        a: "”",
        z: "”"
    },
    {
        a: "„",
        z: "”"
    },
    {
        a: "「",
        z: "」"
    },
    {
        a: "»",
        z: "«"
    },
    {
        a: "﹁",
        z: "﹂"
    },
    {
        a: "‘",
        z: "’"
    },
    {
        a: "⟦",
        z: "⟧"
    },
    {
        a: "‹",
        z: "›"
    },
    {
        a: "⸤",
        z: "⸥"
    },
    {
        a: "【",
        z: "】"
    },
    {
        a: "⁅",
        z: "⁆"
    },
    {
        a: "﴾",
        z: "﴿"
    },
    {
        a: "｛",
        z: "｝"
    },
    {
        a: "〝",
        z: "〞"
    },
    {
        a: "｟",
        z: "｠"
    },
    {
        a: "〈",
        z: "〉"
    },
    {
        a: "《",
        z: "》"
    },
    {
        a: "（",
        z: "）"
    },
];
exports.default = exports.list;
